/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AdminReviewReservedMarkTransferRequestBodyDto } from '../../models/admin-review-reserved-mark-transfer-request-body-dto';
import { ReservedMarkTransferReviewResultDto } from '../../models/reserved-mark-transfer-review-result-dto';

export interface AdminRejectReservedMarkTransferRequest$Params {
  body: AdminReviewReservedMarkTransferRequestBodyDto;
}

export function adminRejectReservedMarkTransferRequest(
  http: HttpClient,
  rootUrl: string,
  params: AdminRejectReservedMarkTransferRequest$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ReservedMarkTransferReviewResultDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    adminRejectReservedMarkTransferRequest.PATH,
    'put',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReservedMarkTransferReviewResultDto>;
      }),
    );
}

adminRejectReservedMarkTransferRequest.PATH =
  '/admin/surveyMarks/reserved/transfer-request/reject';
